import { ReactNode, useCallback, useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';
import { ToastStatus } from '../types/Status';

const styles = {
  toast: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '4px',
  },
};

export const useToast = ({
  condition,
  status,
  message,
  reset,
  duration = 5000,
}: {
  condition: string | boolean | null;
  status: Exclude<ToastStatus, null>;
  message: ReactNode;
  reset?: () => void;
  duration?: number;
}) => {
  const toastIdRef = useRef<string | null>(null);

  const showToast = useCallback(() => {
    const func =
      status === 'loading'
        ? toast.loading
        : status === 'success'
          ? toast.success
          : toast.error;
    const id = func(
      <div style={styles.toast}>
        <p>{message}</p>
      </div>,
      { duration }
    );
    toastIdRef.current = id;
  }, [status, message, duration]);

  useEffect(() => {
    if (condition) {
      showToast();
      reset?.();
    } else if (status === 'loading' && toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
      toastIdRef.current = null;
    }
  }, [condition, showToast, reset, status]);
};
